import ReplayIcon from '@mui/icons-material/Replay';
import { useState } from 'react';
import CloseIcon from '../../../../animation/jobs/Cross icon.svg';
import { ServiceApi } from '../../Service/ServiceApi';
import jobUtils from '../../utils/jobUtils';
import styles from './JobCard.module.css';



const JobCard = ({ job, onClick, isSelected }) => {
  const [isHidden, setIsHidden] = useState(false);

  const Token=localStorage.getItem("token")

  const handleRemove = async(e) => {
      try {  
        await ServiceApi.DeleteApi(Token,job.id);

      } catch (error) {
        console.error("Delete error:", error); 
      } 
    e.stopPropagation();
    setIsHidden(true);
  };

  const handleRestore = (e) => {
    e.stopPropagation();
    setIsHidden(false);
  };

  const companyName = job.CompanyData?.company_name || "Unknown Company";


  const companyAddress = job.CompanyData?.company_address;




  return (
    <div
      className={`${styles.jobCard} ${isSelected ? styles.selected : ''} ${isHidden ? styles.hidden : ''}`}
      onClick={!isHidden ? onClick : undefined}
    >
      {/* Hide/Restore button */}
      <div className={styles.iconButton} onClick={isHidden ? handleRestore : handleRemove}>
        {isHidden ? <ReplayIcon sx={{ color: "#666" }} /> : <img src={CloseIcon} alt="Close Icon" style={{ color: "#666" }} className='CrossIcon'/>}
      </div>



      <div className={styles.jobCardContent}>
       

        <div className={styles.companyLogoContainer}>
          <div className={styles.companyLogo}>
            {job?.CompanyData.company_logo ? (
              <img
                src={jobUtils.decodeIfProxy(job?.CompanyData?.company_logo) || '/Image/fallback-company.png'}
                alt={`${job?.CompanyData?.company_name ?? 'Company'} logo`}
                className={styles.companyLogo}
                onError={(e) => {
                  const img = e.currentTarget;
                  // if current src still contains "/media/" try switching to the decoded original host
                  if (img.src && img.src.includes('/media/')) {
                    const decoded = jobUtils.decodeIfProxy(job?.CompanyData?.company_logo);
                    if (decoded && decoded !== img.src) {
                      img.onerror = null; // prevent infinite loop
                      img.src = decoded;
                      return;
                    }
                  }
                  
                  img.onerror = null;
                  img.src = '/Image/fallback-company.png';
                }}
              />
            ) : (
              <div className={styles.companyLogo}>
                {companyName.charAt(0).toUpperCase()}
              </div>
            )}
          </div>
        </div>

      
        <div className={styles.jobDetails}>
          <h3 className={styles.jobTitle}>{job?.title}</h3>
          <p className={styles.companyName}>{companyName}</p>

          {!isHidden && (
            <>
              <p className={styles.jobLocation}>
                {companyAddress}{" "}
                {job?.remote && job.remote !== "NA" && (
                  job.remote === "onsite" 
                    ? "(On-Site)" 
                    : job.remote === "remote" 
                      ? "(Remote)" 
                      : null
                )}
              </p>

              <div className={styles.jobMeta}>
                {job?.isApplied ? (
                  <span className={styles.applied}>
                    Applied {jobUtils.timeAgo(job.isApplied.applied_at)}
                  </span>
                ): job?.timestamp && (
                  <span className={styles.postedDate}>
                    {jobUtils.timeAgo(job.timestamp)}
                  </span>
                )}
              </div>
            </>
          )}

          {isHidden && <p className={styles.hiddenMessage}>We won’t show you this job again.</p>}
        </div>
      </div>
    </div>
  );
};

export default JobCard;
